"use strict";

var PZSection = function PZSection(props) {
    var sections = Array.from(Object.keys(props.pzSections), function (k) {
        return props.pzSections[k];
    });
    var sorted_sections = sections.sort(function (a, b) {
        return a.sort_id - b.sort_id;
    });
    return React.createElement(
        "ul",
        { className: "pz-custom-tab-item" },
        sorted_sections.map(function (pzSection, index) {
            //let pzSection = props.pzSections[pzSectionKey];
            var pzSectionTabs = [];
            pzSectionTabs = pzSection.promize_tabs.length > 0 && pzSection.promize_tabs.sort(function (a, b) {
                return a.sort_id - b.sort_id;
            });
            return React.createElement(
                "li",
                { key: index,
                    className: pzSection.promize_section_id == props.pzActiveSection ? "pz-custom-tab-items active" : "pz-custom-tab-items",
                    onClick: function onClick(e) {
                        e.preventDefault(), props.pzSection.pzActiveSectionHandler(pzSection.promize_section_id);
                    } },
                React.createElement(
                    "button",
                    { className: pzSection.promize_section_id == props.pzActiveSection ? "pz-custom-tab-btn active" : "pz-custom-tab-btn" },
                    pzSection.section_icon && React.createElement("img", { src: props.pzImgUrl + pzSection.section_icon.replace(props.pzReplaceImg, '') }),
                    pzSection.section_name
                ),
                React.createElement(
                    "ul",
                    { className: pzSection.promize_section_id == props.pzActiveSection ? "pz-custom-sm-tab-item active" : "pz-custom-sm-tab-item" },
                    pzSectionTabs.length > 0 && Object.keys(pzSectionTabs).map(function (tab_key, tab_index) {
                        return React.createElement(
                            "li",
                            { key: tab_index, className: props.pzActiveTab[pzSectionTabs[tab_key].promize_section_id] == pzSectionTabs[tab_key].promize_tab_id ? "pz-custom-tab-items active" : "pz-custom-tab-items", onClick: function onClick(e) {
                                    e.preventDefault(), props.HomeComponent.pzSetSelectedTab(pzSectionTabs[tab_key].promize_tab_id, pzSectionTabs[tab_key]);
                                } },
                            React.createElement(
                                "button",
                                { className: "pz-custom-tab-btn" },
                                pzSectionTabs[tab_key].tab_icon && React.createElement(
                                    "span",
                                    { className: "pz-tab-icon" },
                                    React.createElement("img", { src: props.pzImgUrl.concat(pzSectionTabs[tab_key].tab_icon.replace(props.pzReplaceImg, '')) })
                                ),
                                pzSectionTabs[tab_key].tab_name
                            )
                        );
                    })
                )
            );
        })
    );
};